import React__default, { useEffect } from 'react';
import MessageFilePart from '../../MessageFilePart/index.js';

var FileMessage = function FileMessage(_a) {
  var message = _a.message,
      myself = _a.myself,
      onLoaded = _a.onLoaded;
  useEffect(function () {
    onLoaded();
  }, []);
  return React__default.createElement(React__default.Fragment, null, message.parts.map(function (part, idx) {
    return React__default.createElement(MessageFilePart, {
      part: part,
      key: idx,
      myself: myself
    });
  }));
};

FileMessage.handlesMessage = function (message) {
  return message.parts.length === 1 && message.parts[0].type === 'FILE';
};

export default FileMessage;
//# sourceMappingURL=index.js.map
